<label *ngIf="isFocused" class="label-wrapper-label">{{ label }}</label>
<div class="label-wrapper-content">
	<ng-content></ng-content>
</div>
